import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { StringDto } from '@models/basic/string-dto';

@Injectable({
    providedIn: 'root'
})
export class SettingService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    policy(): Observable<StringDto> {
        return this.get('settings/policy', { app: 'center', version: 1 });
    }
}
